export default {
  agency_key: '',
  mode: '',
  beian: '',
  beian_gn: '',


  chat_url: 'https://chat.ruan.net',
  address: '湖北省武汉市光谷软件园F2栋801室',
  uc_host: 'https://i.ruan.net',
  site_host: 'https://www.ruan.net',
  special_url: '/',
  site_title: '软盟-软文精准营销平台',
  welcome_title: '软盟 — 软文精准营销平台！',
  site_short_title: '软盟',
  site_subtitle: '软文精准营销平台',
  company_name: '武汉亿哲网络科技有限公司',
  copyright: '© 2020 武汉亿哲网络科技有限公司',
  logo: 'https://www.ruan.net/images/logo.png',
  favicon: 'https://www.ruan.net/images/ico.png',
  payment: '',
  qq: '3276788702',
  tel: '13072161583',
  recharge_tel: '13072161583',
  company_account_id: '42050110239900000416',
  company_bank: '中国建设银行股份有限公司武汉软件园科技支行',
  company_bank_name: '武汉亿哲营销策划有限公司',
  alipay_account_id: '',
  alipay_name: '',
  alipay_pic: '',
  section_id: 0,
  belonger_id: 0,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 